import React, { useEffect } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect
} from "react-router-dom";
import Layout from './Layout/Layout'
import Login from "./Authentication/Login"
import Banks from "./Banks/Banks";
import Dashboard from "./Dashboard/Dashboard";
import Accounts from "./Accounts/Accounts";
import ChequeSettings from './ChequeSettings/ChequeSettings'
import { useRecoilState } from 'recoil'
import { loggedInState } from '../recoil/atoms'
import axios from 'axios'

const AppRouter = () => {
    // Check if user is logged in or not
    const [isLoggedIn, setLoggedInState] = useRecoilState(loggedInState)
    const getAccessToken = async () => {
        const response = await axios.post('users/refresh/')
        if (response.status === 200) {
            setLoggedInState(true)
            localStorage.setItem('access', response.data.access)
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.access
        }
    }
    useEffect(() => {
        getAccessToken()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <Router>
            <Switch>
                {isLoggedIn ? (
                    // Private routes
                    <>
                        {/* Dashboard */}
                        <Route exact path="/dashboard" >
                            <Layout >
                                <Dashboard />
                            </Layout>
                        </Route>

                        {/* Banks */}
                        <Route exact path="/banks">
                            <Layout>
                                <Banks />
                            </Layout>
                        </Route>

                        {/* Cheque settings */}
                        <Route exact path="/cheque_settings">
                            <Layout>
                                <ChequeSettings />
                            </Layout>
                        </Route>

                        {/* Accounts */}
                        <Route exact path="/accounts">
                            <Layout>
                                <Accounts />
                            </Layout>
                        </Route>

                        {/* Default private route */}
                        <Route>
                            <Redirect to="/dashboard" />
                        </Route>
                    </>
                ) : (
                        // Public routes
                        <>
                            {/* Login */}
                            < Route exact path="/login" render={props => (
                                <Login {...props} />
                            )} />

                            {/* Default private route */}
                            <Route>
                                <Redirect to="/login" />
                            </Route>
                        </>
                    )}
            </Switch>
        </Router >
    )
}

export default AppRouter